import React from 'react'
import { useLocalStorage } from 'react-use'

import BoxImageSrc from '@sketch/icons/box-illustration.png'
import BoxRetinaImageSrc from '@sketch/icons/box-illustration@2x.png'
import { localStorageKeys } from '@sketch/constants'

import { Image, LinkButton } from '@sketch/components'

import {
  Wrapper,
  Title,
  Description,
  ActionsContainer,
  IllustrationContainer,
  StyledButton,
  Lights,
  LightYellow,
  LightBlue,
  LightRed,
} from './BrandNewProfileBanner.styles'
import { SKETCH_WEBSITE } from '@sketch/env-config'

export const BrandNewProfileBanner: React.FC = () => {
  const [bannerSeen, setBannerSeen] = useLocalStorage(
    localStorageKeys.newPublicProfile,
    false
  )

  const handleDismiss = () => {
    setBannerSeen(true)
  }

  if (bannerSeen) {
    return null
  }

  return (
    <Wrapper>
      <Title>Make Your Profile Shine</Title>
      <Description>
        Adding great cover images and descriptions to your documents will make
        your profile stand out and help others discover what you’re sharing.
      </Description>
      <ActionsContainer>
        <LinkButton
          size="32"
          variant="secondary-untinted"
          href={`${SKETCH_WEBSITE}/redirect/web/public-profile-docs`}
          external
        >
          Learn More ↗
        </LinkButton>
        <StyledButton
          size="32"
          variant="secondary-untinted"
          onClick={handleDismiss}
        >
          Don&apos;t show again
        </StyledButton>
      </ActionsContainer>

      <IllustrationContainer>
        <Lights>
          <LightYellow />
          <LightBlue />
          <LightRed />
        </Lights>
        <Image
          alt="Community"
          src={BoxImageSrc}
          srcSet={`${BoxRetinaImageSrc} 2x`}
        />
      </IllustrationContainer>
    </Wrapper>
  )
}
